module.exports = __webpack_public_path__ + "img/subbanner.0f633b5f.jpg";